<template>
    <v-layout>
        <v-flex md12>
            <v-snackbar
                    :multi-line="$vuetify.breakpoint.smAndDown"
                    class="v-snackbar--customize text-xs-center"
                    :class="{'v-snackbar--customize--mobile': $vuetify.breakpoint.smAndDown}"
                    v-model="show"
                    bottom
                    color="rgba(94, 117, 130, 0.93)"
                    :timeout="0"
                    auto-height
            >
                <span>
                    This website uses cookies to ensure you get the best experience on our website.
                    <router-link v-show="$route.name !== 'cookie-policy'" tag="span" style="cursor: pointer;" class="font-weight-bold" :to="{name:'cookie-policy'}">
                            Learn More!
                    </router-link>
                </span>
                <v-btn
                        outline
                        class="pa-2"
                        color="#fff"
                        @click="dismiss"
                        :ripple="false"
                >
                    <span class="text-capitalize">Got it!</span>
                </v-btn>
            </v-snackbar>
        </v-flex>
    </v-layout>
</template>

<script>
	import moment from "moment"

	export default {
		name: "AppCookiePolicy",
        props:{
			name: {
				type: String,
                default: "bindez_cookie"
            },
            domain: {
				type: String,
                default: '',
            },
            path: {
				type: String,
                default: '/',
            },
            expiresDays:{
				type: Number,
                default : 365
            }

        },
		data() {
			return {
				show: false,
			}
		},
		methods: {
			getCookie(name) {
				const value = `; ${document.cookie}`;
				const parts = value.split(`; ${name}=`)
				return parts.length !== 2 ? undefined : parts.pop().split(';').shift()
			},

			dismiss() {
				this.show = false;
				let exDate = moment().add(this.expiresDays || 365, "days");

				const cookie = [
					`${this.name} = ${1}`,
					`expires = ${exDate}`,
					`path=${this.path || '/'}`,
					`domain=${this.domain}`
				];
                document.cookie = cookie.join(";")
			}
		},

		computed: {
			cookie() {
				return !this.getCookie(this.name)
			}
		},

		beforeMount() {
			this.show = this.cookie;
		}


	}
</script>

<style>
    .v-snackbar--customize.v-snack--active.v-snack.v-snack--bottom > .v-snack__wrapper {
        margin: 0 auto;
        min-width: 100% !important;
        /*height: 75px;*/
    }

    .v-snackbar--customize.v-snack--active.v-snack.v-snack--bottom > .v-snack__wrapper > .v-snack__content {
        width: 60%;
        margin: 0 auto;
    }

    .v-snackbar--customize--mobile.v-snack--active.v-snack.v-snack--bottom > .v-snack__wrapper > .v-snack__content{
        width: 100%;
    }

    .v-snackbar--customize span {
        font-size: 17px;
    }
</style>
